/**
 * The browser half of the write path (SKU-1566). Mirrors session.ts's shape -
 * this module only carries the request; the server decides everything,
 * including which grower (if any) a line routes to.
 */
export interface ReportLine {
    itemId: string;
    qty: number;
}

export type SubmitResult = { ok: true } | { ok: false; error: string };

/** Prefer a real UUID; fall back for environments without crypto.randomUUID
 * (older browsers still turning up on store hardware). Not used for anything
 * security-sensitive - only as an idempotency key so a retried submit can't
 * double-count. */
function randomRequestId(): string {
    const c = globalThis.crypto;
    if (c && typeof c.randomUUID === 'function') return c.randomUUID();
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function newClientRequestId(): string {
    return randomRequestId();
}

export async function submitReport(
    storeId: string,
    lines: ReportLine[],
    clientRequestId: string,
): Promise<SubmitResult> {
    try {
        const res = await fetch('/api/report', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ storeId, lines, clientRequestId }),
        });
        if (res.ok) return { ok: true };

        const body = await res.json().catch(() => null);
        return { ok: false, error: (body && body.error) || `Could not submit (${res.status}).` };
    } catch (err) {
        return {
            ok: false,
            error: err instanceof Error ? err.message : 'Could not submit - check your connection.',
        };
    }
}
